module.exports = __webpack_public_path__ + "static/media/twilio.5c7fb244.png";